import React, { useEffect, useState } from 'react';
import { Search, User, ShoppingBag, Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const SHOP_URL = 'https://shop.purepulsepilates.com';
  const navLinks = [{
    label: 'SHOP',
    href: SHOP_URL
  }, {
    label: 'COLLECTIONS',
    href: SHOP_URL
  }, {
    label: 'ABOUT',
    href: '#'
  }, {
    label: 'JOURNAL',
    href: '#'
  }];
  return <>
      <header className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream shadow-sm' : 'bg-cream/95'}`} data-id="element-82">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-83">
          <button className="lg:hidden" onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-84">
            <Menu size={24} className="text-espresso" data-id="element-85" />
          </button>

          <div className="flex-1 flex justify-center lg:justify-start" data-id="element-86">
            <img src="https://cdn.magicpatterns.com/uploads/jwuPFHfY8i8vKyYQKsjz7s/pure-pulse-logo.png" alt="Pure Pulse Club" className="h-8 lg:h-10" data-id="element-87" />
          </div>

          <nav className="hidden lg:flex items-center gap-8 absolute left-1/2 -translate-x-1/2" data-id="element-88">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-sm uppercase tracking-widest text-espresso hover:text-rust transition-colors relative group" data-id="element-89">
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-px bg-rust transition-all duration-300 group-hover:w-full" data-id="element-90" />
              </a>)}
          </nav>

          <div className="flex items-center gap-4" data-id="element-91">
            <button aria-label="Search" className="hover:text-rust transition-colors" data-id="element-92">
              <Search size={20} data-id="element-93" />
            </button>
            <button aria-label="Account" className="hover:text-rust transition-colors" data-id="element-94">
              <User size={20} data-id="element-95" />
            </button>
            <a href={SHOP_URL} aria-label="Cart" className="hover:text-rust transition-colors relative" data-id="element-96">
              <ShoppingBag size={20} data-id="element-97" />
              <span className="absolute -top-1 -right-1 bg-rust text-white text-xs rounded-full w-4 h-4 flex items-center justify-center" data-id="element-98">
                2
              </span>
            </a>
          </div>
        </div>
      </header>

      {isMobileMenuOpen && <div className="fixed inset-0 z-50 lg:hidden" data-id="element-99">
          <div className="absolute inset-0 bg-espresso/50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-100" />
          <div className="absolute right-0 top-0 h-full w-4/5 max-w-sm bg-cream shadow-xl" data-id="element-101">
            <div className="p-6" data-id="element-102">
              <button onClick={() => setIsMobileMenuOpen(false)} className="absolute top-6 right-6" aria-label="Close menu" data-id="element-103">
                <X size={24} data-id="element-104" />
              </button>
              <nav className="mt-16 flex flex-col gap-6" data-id="element-105">
                {navLinks.map(link => <a key={link.label} href={link.href} className="text-lg uppercase tracking-widest text-espresso hover:text-rust transition-colors" data-id="element-106">
                    {link.label}
                  </a>)}
              </nav>
            </div>
          </div>
        </div>}
    </>;
}